var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createRef, useEffect, useRef, useState } from "react";
import useWindowDimensions from "../../hooks/windowDimensions";
import * as d3 from "d3";
import { useLocation } from "react-router-dom";
export var D3Component = function (_a) {
    var identification = _a.identification, render = _a.render, dependencies = _a.dependencies;
    var _b = useState(Math.random()), key = _b[0], setKey = _b[1];
    var pathname = useLocation().pathname;
    var _c = useWindowDimensions(), width = _c.width, height = _c.height;
    var _d = useState({ y: 600, x: 800 }), _e = _d[0], y = _e.y, x = _e.x, setDimensions = _d[1];
    var ref = createRef();
    var div = useRef();
    useEffect(function () {
        setTimeout(function () {
            setKey(Math.random());
        }, 0);
    }, [pathname]);
    useEffect(function () {
        if (div.current) {
            setDimensions({
                y: div.current.getBoundingClientRect().height,
                x: div.current.getBoundingClientRect().width,
            });
        }
        d3.select(ref.current).selectAll("*").remove();
        render(d3.select(ref.current), ".".concat(identification), {
            height: y,
            width: x,
        });
    }, __spreadArray([key, div.current, width, height], (dependencies || []), true));
    return (_jsx("div", __assign({ className: "".concat(identification, "-parent"), ref: div, style: { width: "100%", position: "relative" } }, { children: _jsx("svg", { ref: ref, style: {
                height: y,
                width: x,
                marginRight: "0px",
                marginLeft: "0px",
            }, className: identification }) }), key));
};
